const VALUES = {
  31: 'open',
  32: 'smooth',
  33: 'rough'
}

const riverIceDataTransform = array => {

  const data = array.reduce((object, item) => {
    const { timestamp, type, value, gridcode } = item
    const key = VALUES[type]

    object[timestamp]
      ? object[timestamp][key] = value
      : object[timestamp] = { [key]: value }

    return object
  }, {})

  const dataArray = Object.keys(data).map(key => {
    const { open = 0, smooth = 0, rough = 0 } = data[key]
    const values = { open, smooth, rough }

    const sum = Object.keys(values).reduce((acc, key) => {
      const value = values[key]
      return value ? acc + value : acc
    }, 0)

    const nestedDataArray = Object.keys(values).map(type => (
      {
        timestamp: key,
        type,
        value: values[type] / sum
      }))
    return [].concat.apply([], nestedDataArray)
  })

  return [].concat.apply([], dataArray)
}

export default riverIceDataTransform



// WEBPACK FOOTER //
// ./src/utility/riverIceDataTransform.js